import { Component, ReactNode } from 'react'
import { logSystemError } from '@/lib/systemLogger'

interface Props {
  children: ReactNode
  module?: string
}
interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    void logSystemError(error, {
      module: this.props.module || 'react-error-boundary',
      action: 'render',
      severity: 'critical',
      requestPayload: { componentStack: info?.componentStack ?? null },
    })
  }

  handleReload = () => {
    try {
      if ('caches' in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)))
      }
    } catch { /* noop */ }
    window.location.reload()
  }

  handleHome = () => {
    window.location.assign('/')
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background p-6 text-foreground">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 text-center shadow-lg">
          <h2 className="text-xl font-extrabold text-foreground">Ocorreu um erro nesta página</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Nossa equipe técnica foi notificada automaticamente. Você pode tentar recarregar a página ou voltar ao início.
          </p>
          <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center">
            <button
              onClick={this.handleReload}
              className="rounded-lg bg-primary px-4 py-2 text-sm font-bold text-primary-foreground hover:opacity-90"
              type="button"
            >
              Recarregar página
            </button>
            <button
              onClick={this.handleHome}
              className="rounded-lg border border-border bg-secondary px-4 py-2 text-sm font-semibold text-secondary-foreground hover:bg-muted"
              type="button"
            >
              Voltar ao início
            </button>
          </div>
        </div>
      </div>
    )
  }
}
